import { Box, Card, Typography, Button } from "@mui/material";
import { CalendarToday } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

// Função para formatar a data
const formatarData = (data) => {
  const dataObj = new Date(data);
  const dia = String(dataObj.getDate()).padStart(2, "0");
  const mes = String(dataObj.getMonth() + 1).padStart(2, "0");
  const ano = dataObj.getFullYear();
  return `${dia}/${mes}/${ano}`;
};

const DetalhesPublicacao = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const publicacao = location.state; // Dados enviados via estado de navegação

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!publicacao) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <Typography variant="h6">Nenhuma publicação encontrada!</Typography>
        <Button
          variant="contained"
          sx={{ marginTop: 2 }}
          onClick={() => navigate(-1)} // Voltar para a página anterior
        >
          Voltar
        </Button>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        padding: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
      }}
    >
      <Typography variant="h4" sx={{ fontWeight: "bold" }}>
        {publicacao.titulo}
      </Typography>
      <Card
        sx={{
          padding: 3,
          maxWidth: 600,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 2,
          borderRadius: 2,
        }}
      >
        <Typography
          variant="body1"
          sx={{
            display: "flex",
            alignItems: "center",
            color: "text.secondary",
            gap: 1,
          }}
        >
          <CalendarToday fontSize="small" />
          {/* Exibindo a data de publicação (publicationDate) formatada */}
          {formatarData(publicacao.publicationDate)}
        </Typography>
        <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
          {publicacao.descricao}
        </Typography>
      </Card>
      <Button variant="contained" onClick={() => navigate(-1)}>
        Voltar
      </Button>
    </Box>
  );
};

export default DetalhesPublicacao;
